var exports = {
  "ST": "FavoritesChannelListContent.module__channelBadgeSelected___dDR4MW",
  "pJ": "FavoritesChannelListContent.module__channelBadgeSelectedIcon___dDR4MW",
  "Vm": "FavoritesChannelListContent.module__favoriteItemContainer___dDR4MW",
  "eb": "FavoritesChannelListContent.module__favoriteItem___dDR4MW",
  "bu": "FavoritesChannelListContent.module__favoriteItemDefault___dDR4MW",
  "Vb": "FavoritesChannelListContent.module__favoriteItemSelected___dDR4MW",
  "q6": "FavoritesChannelListContent.module__favoriteItemOver___dDR4MW",
  "xQ": "FavoritesChannelListContent.module__favoriteItemMuted___dDR4MW",
  "H": "FavoritesChannelListContent.module__avatarContainer___dDR4MW",
  "my": "FavoritesChannelListContent.module__avatar___dDR4MW",
  "rZ": "FavoritesChannelListContent.module__avatarPlaceholder___dDR4MW",
  "XQ": "FavoritesChannelListContent.module__channelBadge___dDR4MW",
  "gg": "FavoritesChannelListContent.module__channelBadgeIcon___dDR4MW",
  "QC": "FavoritesChannelListContent.module__displayName___dDR4MW",
  "Hq": "FavoritesChannelListContent.module__actionsContainer___dDR4MW",
  "af": "FavoritesChannelListContent.module__categoryItem___dDR4MW",
  "Yq": "FavoritesChannelListContent.module__categoryContent___dDR4MW",
  "yb": "FavoritesChannelListContent.module__categoryName___dDR4MW",
  "Yl": "FavoritesChannelListContent.module__categoryIcon___dDR4MW",
  "wp": "FavoritesChannelListContent.module__categoryActions___dDR4MW",
  "Ef": "FavoritesChannelListContent.module__hoverAffordance___dDR4MW",
  "It": "FavoritesChannelListContent.module__categoryAddButton___dDR4MW",
  "n3": "FavoritesChannelListContent.module__categoryAddButtonIcon___dDR4MW",
  "NP": "FavoritesChannelListContent.module__navigationContainer___dDR4MW",
  "r0": "FavoritesChannelListContent.module__channelGroupsContainer___dDR4MW",
  "kj": "FavoritesChannelListContent.module__uncategorizedGroup___dDR4MW",
  "Mn": "FavoritesChannelListContent.module__keyboardFocus___dDR4MW",
  "LA": "FavoritesChannelListContent.module__emptyHint___dDR4MW",
};

module.exports = exports;
